import React from "react";
import { useSelector } from "react-redux";
import { selectUsers } from "./users-selectors";
import { List } from "@mui/material";

import UsersPageItem from "./usuarios-tab/users-page-item";
import { filterUsers } from "./users-page-utils";

function UsersPageMobile({ filter }) {
  const users = useSelector(selectUsers);
  const filteredUsers = filterUsers(users, filter);
  //
  return (
    <>
      <List disablePadding>
        {filteredUsers?.map((user) => (
          <UsersPageItem
            key={user.id}
            id={user.id}
            email={user.email}
            name={user.nome}
            status={user.status}
            dateAccess={user.data_acesso}
          />
        ))}
      </List>
    </>
  );
}

export default UsersPageMobile;
